import { createClient } from '@supabase/supabase-js';
import AsyncStorage from '@react-native-async-storage/async-storage';

const supabaseUrl = 'https://czsnacfquiviyewkjynd.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImN6c25hY2ZxdWl2aXlld2tqeW5kIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM0OTAxNTcsImV4cCI6MjA2OTA2NjE1N30.YRInlWPtqklqUkXsFqe1HoDFVMakOAjztiSdceC3uGI';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage: AsyncStorage,
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: false,
  },
});
